import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import CustomModal from '../../../blocks/custom-modal';
import InfoBox from '../../../blocks/messages/info-box';

/**
 * ConfirmSendFolderModal Component
 * 
 * This component displays a modal for sending a folder by email.
 * It takes `open`, `onClose` as props.
 * 
 * Props:
 * - open (boolean): Controls the modal visibility.
 * - onClose (function): Function to close the modal.
 * 
 * @param {object} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ConfirmSendFolderModal = ({ open, onClose }) => {

    const navigate = useNavigate(); // Hook for navigation

    /**
     * Handles the confirmation to send the folder by email
     * 
     * @returns {void}
     */
    const handleConfirm = async () => {
        navigate('/'); // Navigate to home
    };

    // Return null if the modal is not open
    if (!open) return null;

    // Render the modal
    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={'Attention'}
            handleSave={handleConfirm}
            handleSaveLabel={"Continuer vers l'accueil"}
            onCloseLabel={"Revenir au dossier"}
        >
            <InfoBox
                type="warning"
                text={"Vous n'avez pas transmis le dossier. Souhaitez vous vraiment quitter cette page ? Vous pourrez revenir sur le dossier plus tard pour le transmettre."}
                disabledCloseBtn={true}
                
            />
        </CustomModal>
    );
};

// Prop types for the ConfirmSendFolderModal component
ConfirmSendFolderModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ConfirmSendFolderModal;
